var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadErr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(1.000000, 0.000000)",
    stroke: "#FF5252",
    fillRule: "nonzero",
    fill: "#FF5252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5132383,15.0203666 L9.7230143,10.8105906 C10.0162933,10.5173116 10.0162933,10.0468432 9.7230143,9.7535642 C9.4297352,9.4602851 8.9592668,9.4602851 8.6659878,9.7535642 L5.7331976,12.6863544 L5.7331976,1.47454175 C5.7331976,1.05906314 5.3971487,0.72301426 4.9816701,0.72301426 C4.5661914,0.72301426 4.2301426,1.05906314 4.2301426,1.47454175 L4.2301426,12.6802444 L1.2973523,9.7474542 C1.0040733,9.4541752 0.5336049,9.4541752 0.2403259,9.7474542 C-0.0529532,10.0407332 -0.0529532,10.5112016 0.2403259,10.8044807 L4.4501018,15.0142566 C4.5967413,15.1608961 4.7861507,15.2342159 4.9816701,15.2342159 C5.1771894,15.2342159 5.3665988,15.1670061 5.5132383,15.0203666 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadErr);
export default __webpack_public_path__ + "static/media/download-err.b8390917ca4da69e24d7161f579c719a.svg";
export { ForwardRef as ReactComponent };